import React, { useState, useEffect, useCallback } from 'react';

import DatePicker from 'antd/es/date-picker';

import { Row, Col } from 'components/layout';
import { Text } from 'components/Text';
// styles
import '../styles/datePicker.css';

export const PeriodDatePicker = ({ ...rest }) => {
  return (
    <DatePicker
      format={'DD MMM yyyy'}
      showToday={false}
      dropdownClassName='period-date-picker-dropdown'
      {...rest}
    />
  );
};

export const PeriodDateRangePicker = ({ value, onChange }) => {
  const [dateRange, setDateRange] = useState([null, null]);

  useEffect(() => {
    if (Array.isArray(value)) {
      let modified = false;
      const newRange = dateRange.map((dt, i) => {
        const newDt = value[i];
        if (dt === newDt) return dt;
        if (dt !== null) {
          if (dt.isSame(newDt)) return dt;
        }
        modified = true;
        return newDt;
      });
      
      if (modified) {
        setDateRange(newRange);
      }
    }
  }, [value, dateRange]);

  const onStartDateChanged = useCallback((selectedDate) => {
    const newRange = [...dateRange];
    if (selectedDate) {
      newRange[0] = selectedDate;
    } else {
      newRange[0] = null;
    }

    setDateRange(newRange);
    if (typeof onChange === 'function') {
      onChange(newRange);
    }
  }, [dateRange, onChange]);

  const onEndDateChanged = useCallback((selectedDate) => {
    const newRange = [...dateRange];
    if (selectedDate) {
      newRange[1] = selectedDate;
    } else {
      newRange[1] = null;
    }
    
    setDateRange(newRange);
    if (typeof onChange === 'function') {
      onChange(newRange);
    }
  }, [dateRange, onChange]);

  return (
    <Row gutter={12}>
      <Col>
        <Text
          style={{
            display: 'block',
            marginBottom: '2px',
          }}
        >
          Start Date
        </Text>
        <PeriodDatePicker
          value={dateRange[0]}
          onChange={onStartDateChanged}
          style={{ width: '215px' }}
          allowClear={false}
        />
      </Col>
      <Col>
      <Text
          style={{
            display: 'block',
            marginBottom: '2px',
          }}
        >
          End Date
        </Text>
        <PeriodDatePicker
          value={dateRange[1]}
          onChange={onEndDateChanged}
          style={{ width: '215px' }}
          allowClear={true}
          disabledDate={currentDate => {
            if (dateRange[0] && currentDate) {
              return currentDate.dayOfYear() < dateRange[0].dayOfYear();
            }
            return false;
          }}
        />
      </Col>
    </Row>
  );
};

export default PeriodDatePicker;
